/* eslint-disable max-lines-per-function */
import isNewsServiceName from "helpers/isNewsServiceName";
import useNewsCritics from "hooks/useNewsCritics";
import useReviews from "hooks/useReviews";
import { useCallback, useMemo } from "react";
const useActionsCheckbox = ({ inputId, isNeedsDisplayList = true, label, serviceName, serviceType, setValueName, valueName }) => {
    const newsCriticsContext = useNewsCritics();
    const reviewsContext = useReviews();
    const { state: reviewsState } = reviewsContext;
    const { state: newsCriticsState } = newsCriticsContext;
    const isDisplayList = Boolean(serviceType === "news" && isNewsServiceName(serviceName)
        ? newsCriticsState[serviceName].display.length
        : reviewsState[serviceName].display.length);
    const checked = useMemo(() => 
    // We need to do this as typescript isn't gonna allow
    // stateByServiceName without checking for type first
    serviceType === "news" &&
        setValueName !== "setIsAllAroundGather" &&
        valueName !== "isAllAroundGather" &&
        isNewsServiceName(serviceName)
        ? newsCriticsState[serviceName][valueName]
        : reviewsState[serviceName][valueName], [
        newsCriticsState,
        reviewsState,
        serviceName,
        serviceType,
        setValueName,
        valueName
    ]);
    /** Select the stable setter for "news" action checkboxes. */
    const setNewsCheckboxValue = useMemo(() => {
        switch (setValueName) {
            case "setIsOnlyNew": {
                return newsCriticsContext.setIsOnlyNew;
            }
            case "setIsOnlyPresent": {
                return newsCriticsContext.setIsOnlyPresent;
            }
            default: {
                return newsCriticsContext.setIsShowFlagged;
            }
        }
    }, [
        newsCriticsContext.setIsOnlyNew,
        newsCriticsContext.setIsOnlyPresent,
        newsCriticsContext.setIsShowFlagged,
        setValueName
    ]);
    /** Select the stable setter for "reviews" action checkboxes. */
    const setReviewsCheckboxValue = useMemo(() => {
        switch (setValueName) {
            case "setIsAllAroundGather": {
                return reviewsContext.setIsAllAroundGather;
            }
            case "setIsOnlyNew": {
                return reviewsContext.setIsOnlyNew;
            }
            case "setIsOnlyPresent": {
                return reviewsContext.setIsOnlyPresent;
            }
            default: {
                return reviewsContext.setIsShowFlagged;
            }
        }
    }, [
        reviewsContext.setIsAllAroundGather,
        reviewsContext.setIsOnlyNew,
        reviewsContext.setIsOnlyPresent,
        reviewsContext.setIsShowFlagged,
        setValueName
    ]);
    const onChange = useCallback(() => {
        if (serviceType === "news" &&
            setValueName !== "setIsAllAroundGather" &&
            isNewsServiceName(serviceName)) {
            setNewsCheckboxValue(!checked, serviceName);
        }
        else {
            setReviewsCheckboxValue(!checked, serviceName);
        }
    }, [
        checked,
        setNewsCheckboxValue,
        setReviewsCheckboxValue,
        serviceName,
        serviceType,
        setValueName
    ]);
    return useMemo(() => ({
        checked,
        disabled: isNeedsDisplayList === true && !isDisplayList,
        inputId,
        label,
        name: valueName,
        onChange
    }), [
        checked,
        inputId,
        isDisplayList,
        isNeedsDisplayList,
        label,
        onChange,
        valueName
    ]);
};
export default useActionsCheckbox;
